import * as eventTypes from './eventTypes'
import * as actionTypes from './actionTypes'

var events = {}

events[actionTypes.WS_CONNECT_FINISHED] = function (action) {
  if (action.error) {
    // TODO: Handle the error case?
  } else {
    return {
      type: eventTypes.WS_CHANGE,
      args: { platform: action.meta.platform }
    }
  }
}

events[actionTypes.LOST_CONNECTION] = function (action) {
  return {
    type: eventTypes.WS_CHANGE,
    args: { platform: action.meta.platform }
  }
}
// TODO: Differentiate between types of disconnects?
events[actionTypes.WS_DISCONNECT_FINISHED] = events[actionTypes.LOST_CONNECTION]

// TODO: Does an app care that we're trying to connect/reconnect?
events[actionTypes.WS_ATTEMPT_CONNECT] = function (action) {
  return {
    type: eventTypes.WS_CHANGE,
    args: { platform: action.meta.platform }
  }
}

export default events
